import { init } from "@sentry/browser";

if (process.env.REACT_APP_SENTRY_DSN) {
  init({
    dsn: process.env.REACT_APP_SENTRY_DSN
  });
}
